module.exports = __webpack_public_path__ + "img/bg-login.7dd8d6b8.png";